import React, { useEffect } from 'react';

import store from 'store';

import Aux from '../../hoc/Auxi';

import styles from'./TableResponsive.module.css';

const TableResponsive = ({ children }) => {
  useEffect(() => {
    const table  = document.querySelector('#table');
    const info = document.querySelector('.info');

    table.addEventListener('scroll', function() {
      if (info && info.classList.contains('visible')) {
        info.classList.remove('visible');
        store.set('tableScroll', true);
      }
    });
  });

  const notice = !store.get('tableScroll') && (
    <div id="info" className="info visible">
      <div className="info-text">Scroll the table horizontally</div>
      <div className="info-hand"></div>
    </div>
  );

  return (
    <Aux>
      <div id="table" className={`${styles['table-responsive']}`}>
        {children}
        {notice}
      </div>
    </Aux>
  );
};

export default TableResponsive;
